module.exports = __webpack_public_path__ + "img/squig2-2.0ce377b.png";